module.exports = __webpack_public_path__ + "img/second-slide-logo.65421deb.png";